module.exports = __webpack_public_path__ + "img/prev-icon-with-text-b1.035e8943.webp";